import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { AutoPointModifyComponent } from "./auto-point-modify/auto-point-modify.component";
import { AutoPointSchoolTableComponent } from "./auto-point-school-table/auto-point-school-table.component";
import { AutoPointTableComponent } from "./auto-point-table/auto-point-table.component";
import { DataService_PBISAuto } from "./shared/data.service";

@Component({
	selector: "app-auto-pbissetup",
	templateUrl: "./auto-pbissetup.component.html",
	styleUrls: ["./auto-pbissetup.component.css"],
})
export class AutoPBISSetupComponent implements OnInit {
	constructor(
		private autoService: DataService_PBISAuto,
		private selectService: SchoolselectorService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////

	subscription: any;

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	School: any;
	SelectedAutoPoint: any;

	SchoolExpand: any = false;

	@ViewChild(AutoPointTableComponent)
	mainTableRef: AutoPointTableComponent;

	@ViewChild(AutoPointSchoolTableComponent)
	schoolTableRef: AutoPointSchoolTableComponent;

	errorMessage: any = "";

	///////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////////

	onRefresh() {
		if (this.mainTableRef != null && this.mainTableRef.loading != true) {
			this.mainTableRef.onRefresh();
		}
	}

	onAdd() {
		this.errorMessage = "";

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(AutoPointModifyComponent, {
			header: "Add Auto Point",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				EditMode: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.mainTableRef.onRowUnselect(null);
				this.schoolTableRef.onRowUnselect(null);
				this.onRefresh();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedAutoPoint == null) {
			this.errorMessage = "Select a point to edit";
			return;
		}

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(AutoPointModifyComponent, {
			header: "Edit Auto Point",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				EditMode: true,
				PointsAutomatedItemTypeID: this.SelectedAutoPoint.PointsAutomatedItemTypeID,
				PointsItemID: this.SelectedAutoPoint.PointsItemID,
				lstSchools: this.SelectedAutoPoint.lstSchools,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.mainTableRef.onRowUnselect(null);
				this.schoolTableRef.onRowUnselect(null);
				this.onRefresh();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedAutoPoint == null) {
			this.errorMessage = "Select a point to delete";
			return;
		}

		var result = this.autoService.AutoPointDelete(this.SelectedAutoPoint.PointsAutomatedItemTypeID, this.SelectedAutoPoint.PointsItemID);
		result.subscribe(
			(response: any) => {
				if (response.Status === true) {
					this.onRefresh();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the point: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;
	}

	OnSelectedChanged(val) {
		this.SelectedAutoPoint = val;
	}

	///////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////////

	GetSchoolCount() {
		if (this.SelectedAutoPoint == null) {
			return "0";
		} else {
			return this.SelectedAutoPoint.lstSchool.length;
		}
	}

	///////////////////////////////////////////////////////////////////////////////
}
